<template>
  <div class="pagination" v-if="total > pageSize">
    <span class="pagination__info">{{ startItem }}–{{ endItem }} of {{ total }}</span>
    <div class="pagination__controls">
      <button class="pagination__btn" :disabled="value === 1" @click="go(value - 1)" aria-label="Previous">‹</button>
      <button
        v-for="(p, i) in pages"
        :key="i"
        class="pagination__btn"
        :class="{ 'pagination__btn--active': p === value, 'pagination__btn--gap': p === '…' }"
        :disabled="p === '…'"
        @click="go(p)"
      >
        {{ p }}
      </button>
      <button class="pagination__btn" :disabled="value === totalPages" @click="go(value + 1)" aria-label="Next">›</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: { type: Number, default: 0 },
    pageSize: { type: Number, default: 15 },
    value: { type: Number, default: 1 }, // current page (v-model)
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    startItem() {
      return this.total === 0 ? 0 : (this.value - 1) * this.pageSize + 1
    },
    endItem() {
      return Math.min(this.total, this.value * this.pageSize)
    },
    pages() {
      const tp = this.totalPages
      const cur = this.value
      const out = []
      if (tp <= 7) {
        for (let i = 1; i <= tp; i++) out.push(i)
        return out
      }
      out.push(1)
      if (cur > 3) out.push('…')
      const s = Math.max(2, cur - 1)
      const e = Math.min(tp - 1, cur + 1)
      for (let i = s; i <= e; i++) out.push(i)
      if (cur < tp - 2) out.push('…')
      out.push(tp)
      return out
    },
  },
  methods: {
    go(p) {
      if (p === '…' || p < 1 || p > this.totalPages || p === this.value) return
      this.$emit('input', p)
    },
  },
}
</script>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 12px 16px;
}
.pagination__info {
  font-size: 12px;
  color: var(--text-muted);
}
.pagination__controls {
  display: flex;
  gap: 4px;
}
.pagination__btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-muted);
  border-radius: var(--radius-sm);
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.pagination__btn:hover:not(:disabled):not(.pagination__btn--gap) {
  background: var(--surface-2);
  color: var(--text);
}
.pagination__btn--active {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
}
.pagination__btn--gap {
  border-color: transparent;
  background: transparent;
  cursor: default;
}
.pagination__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
